export default __webpack_public_path__ + "static/media/una-pausa-png-a1.4b30b534.png";